import SettingPage from "./SettingPage";

export default SettingPage;
